"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HooksContext = require("./HooksContext");
Object.keys(_HooksContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HooksContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HooksContext[key];
    }
  });
});
var _BrandContext = require("./BrandContext");
Object.keys(_BrandContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BrandContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BrandContext[key];
    }
  });
});